export interface FaqItem {
  id: string;
  group: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: "faq-what",
    group: "使用指南",
    question: "黑料百科里的「词条」到底是什么？",
    answer:
      "每个词条围绕一位艺人、创作者或一个具体话题建立，包含人物背景、话题摘要、基本信息表和按日期排列的事件时间线。它更像一份整理好的资料页，而不是一条短消息，方便你按顺序理解事情的来龙去脉。",
  },
  {
    id: "faq-search",
    group: "使用指南",
    question: "怎么快速找到我想看的人物？",
    answer:
      "顶部导航栏右侧的搜索框支持按人物姓名、话题标签和摘要关键词实时匹配，输入后会在下方直接列出候选词条。你也可以从首页的分类入口或榜单页按热度浏览。",
  },
  {
    id: "faq-ranking",
    group: "使用指南",
    question: "榜单的热度是怎么排的？",
    answer:
      "热度值综合了词条的浏览、收藏与近期更新情况，榜单每天更新一次。榜单页还可以按分类筛选，只看某一个领域里讨论最集中的词条。",
  },
  {
    id: "faq-source",
    group: "内容与来源",
    question: "词条里的信息来自哪里？",
    answer:
      "我们只整理公开渠道已经出现过的内容，例如官方账号发布的说明、官方物料以及可追溯的公开报道，并在时间线中标注每个节点的时间。不采用无法核实的匿名说法作为事实结论。",
  },
  {
    id: "faq-unverified",
    group: "内容与来源",
    question: "遇到匿名爆料会怎么处理？",
    answer:
      "如果一条说法没有可核实的来源，词条会在基本信息中标明「信息可信度较低」，并在正文中明确提示读者谨慎判断，不会把它写成既定事实。",
  },
  {
    id: "faq-update",
    group: "内容与来源",
    question: "词条多久更新一次？",
    answer:
      "进入热榜的话题通常每天跟进；已经平息的词条会转为定期回顾，只在出现新的公开信息时更新，并同步调整词条的状态标签。",
  },
  {
    id: "faq-privacy",
    group: "内容与来源",
    question: "会不会收录私人信息？",
    answer:
      "不会。词条只涉及公开活动与公开发言，不收录证件信息、私人联系方式、住址等非公开内容。这也是一条不会妥协的编辑原则。",
  },
  {
    id: "faq-correct",
    group: "联系与纠错",
    question: "我发现词条内容有误，可以怎么反馈？",
    answer:
      "可以通过「联系我们」页面提交纠错，请尽量附上公开来源链接。我们会在核实后修改，并在词条更新时间中记录这次改动。",
  },
  {
    id: "faq-subscribe",
    group: "联系与纠错",
    question: "订阅更新会收到什么内容？",
    answer:
      "每周一封邮件，包含本周新增或更新的词条清单与话题脉络小结，不推送无关广告，随时可以退订。",
  },
  {
    id: "faq-contact",
    group: "联系与纠错",
    question: "想推荐一个话题给你们，怎么提交？",
    answer:
      "在联系页面选择「话题推荐」类型的留言即可。我们会评估该话题是否有足够公开信息支撑，能够梳理出清晰时间线的才会建立词条。",
  },
];